import './landpage.css'
import Header from '../Header/Header'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { FiArrowRight, FiCheck } from 'react-icons/fi'
import TypoAnime from '../typo/TypoAnime'
import Tickertape from '../Tickertape'

const rise = (delay) => ({
    initial: { y: 32, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    transition: { duration: 0.6, delay },
})

const REASSURANCES = ['Start from $100', 'Withdraw to your crypto wallet', 'Accounts protected with 2FA']

const STATS = [
    ['12,400+', 'Satisfied users'],
    ['96+', 'Countries served'],
    ['34,900+', 'Successful withdrawals'],
    ['58,200+', 'Investments managed'],
]

const Landpage = () => {
    const navigate = useNavigate()

    const scrollToSteps = () => {
        document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    return (
        <main className='landpage'>
            <Header />
            <div className='landpage-content-wrapper'>
                <div className="landpage-text-container">
                    <motion.span className="landpage-eyebrow" {...rise(0.1)}>
                        Professional copy trading
                    </motion.span>

                    <motion.h1 {...rise(0.2)}>
                        Your capital, <span className="landpage-accent">mirrored</span> from the experts — <TypoAnime />
                    </motion.h1>

                    <motion.p {...rise(0.35)}>
                        At Ollarin Mirror, we take the complexity out of investing. Our seasoned traders handle every position while you watch your portfolio grow. Step into a smarter, more profitable financial future — guided by professionals who put your returns first.
                    </motion.p>

                    <motion.div className="landpage-cta-row" {...rise(0.45)}>
                        <button className="landpage-cta-primary" onClick={() => navigate('/signup')}>
                            Get started <FiArrowRight />
                        </button>
                        <button className="landpage-cta-secondary" onClick={scrollToSteps}>
                            How it works
                        </button>
                    </motion.div>

                    <motion.ul className="landpage-reassurances" {...rise(0.55)}>
                        {REASSURANCES.map(text => (
                            <li key={text}><FiCheck /> {text}</li>
                        ))}
                    </motion.ul>
                </div>

                <div className="landpage-img-container">
                    <motion.img src="/ollarin-mockup%20(1).png" alt="Ollarin Mirror dashboard on a phone" className='phone' {...rise(0.6)} />
                </div>
            </div>

            <div className="landpage-stats-strip">
                {STATS.map(([value, label]) => (
                    <div className="landpage-stat" key={label}>
                        <strong>{value}</strong>
                        <span>{label}</span>
                    </div>
                ))}
            </div>
            <Tickertape />
        </main>
    )
}

export default Landpage
